import { BaseModel } from '../../../shared/base/base.models';
import { Product } from '../../../inside-layout/routes/products/products.models';

export class GiftPackage extends BaseModel {
    code?: string;
    name?: string;
    description?: string;
    giftPackageItems?: GiftPackageItem[];
}

export class GiftPackageItem extends BaseModel {
    product?: Product | string;
    quantity?: number;
}